import {
  SecretsManagerClient,
  GetSecretValueCommand,
} from "@aws-sdk/client-secrets-manager";

export async function getSecret(region: string, secretName: string) {
  // Check if the secret is already cached in Redis
  // const cachedSecret = await redisClient.get(secretName);
  // if (cachedSecret) {
  //   return JSON.parse(cachedSecret);
  // }

  const accessKeyId = atob(process.env.REACT_APP_AWS_ACCESS_KEY_ID || "");
  const secretAccessKey = atob(
    process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || ""
  );
  const client = new SecretsManagerClient({
    region,
    credentials: {
      accessKeyId,
      secretAccessKey,
    },
  });
  const response = await client.send(
    new GetSecretValueCommand({
      SecretId: secretName,
    })
  );

  if (response && response.SecretString) {
    const data = JSON.parse(response.SecretString); // parse JSON if secrets are stored as JSON
    return data;
  } else {
    throw new Error("Secret not found or invalid");
  }
}
